// @flow

import moveOrderCaveat from '../../../Services/moveOrderCaveat';
import type { MoveOrderCaveatParams } from '../../../types';

export default (params: MoveOrderCaveatParams) => async (dispatch: Function) => dispatch(moveOrderCaveat(params))